export const colorsArray = [
  {
    backgroundColor: 'rgba(115, 103, 240, 0.4)',
    hoverBackgroundColor: 'rgba(115, 103, 240, 1)',
  },
  {
    backgroundColor: 'rgba(40, 199, 111, 0.4)',
    hoverBackgroundColor: 'rgba(40, 199, 111, 1)',
  },
  {
    backgroundColor: 'rgba(255, 159, 67, 0.4)',
    hoverBackgroundColor: 'rgba(255, 159, 67, 1)',
  },
  {
    backgroundColor: 'rgba(0, 207, 232, 0.4)',
    hoverBackgroundColor: 'rgba(0, 207, 232, 1)',
  },
  {
    backgroundColor: 'rgba(230, 230, 231, 0.4)',
    hoverBackgroundColor: 'rgba(230, 230, 231, 1)',
  },
  {
    backgroundColor: 'rgba(234, 84, 85, 0.4)',
    hoverBackgroundColor: 'rgba(234, 84, 85, 1)',
  },
];

export const loginColorsArray = [
  {
    backgroundColor: 'rgba(115, 103, 240, 1)',
  },
  {
    backgroundColor: 'rgba(40, 199, 111, 1)',
  },
  {
    backgroundColor: 'rgba(255, 159, 67, 1)',
  },
  {
    backgroundColor: 'rgba(0, 207, 232, 1)',
  },
  {
    backgroundColor: 'rgba(192, 16, 16, 1)',
  },
  {
    backgroundColor: 'rgba(234, 84, 85, 1)',
  },
];
